var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOhioReversed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon ohio") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#F3F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.959,51.8l8.562,1.874a.244.244,0,0,1,.041.016l1.948,1.089a.235.235,0,0,0,.089.028l4.263.472a.235.235,0,0,0,.121-.018l1.935-.849a.129.129,0,0,1,.137.011l3.3,2.441a.235.235,0,0,0,.127.046l2.427.135h.013a.236.236,0,0,0,.235-.216l.133-1.572a.153.153,0,0,1,.035-.088L43.692,53.8a.24.24,0,0,0,.068-.141l.31-2.86a.137.137,0,0,1,.12-.116l2.228-.289a.237.237,0,0,0,.2-.192l.686-3.776a.129.129,0,0,1,.114-.1l1.83-.294a.235.235,0,0,0,.171-.124L52.8,39.373a.168.168,0,0,1,.075-.071l1.665-.693a.234.234,0,0,0,.143-.252l-3.3-22.493a.235.235,0,0,0-.233-.2H49.41a.233.233,0,0,0-.125.036l-8.052,5.03a.156.156,0,0,1-.12.019l-1.571-.295a.252.252,0,0,0-.151.022l-2.714,1.4L33.79,24.121a.184.184,0,0,1-.1.024l-2.1-.243a.14.14,0,0,1-.056-.26l1.644-1.047a.236.236,0,0,0-.076-.43l-3.42-.758a.224.224,0,0,0-.078,0L15.518,23.076a.233.233,0,0,0-.158.088.238.238,0,0,0-.049.174L18.775,51.6A.235.235,0,0,0,18.959,51.8Z",
    fill: "#00789E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOhioReversed);
export default __webpack_public_path__ + "static/media/ohio-reversed.4073ad1e1b75e57522111181c71b573c.svg";
export { ForwardRef as ReactComponent };